
























































































































import { dateFilter } from "@/utils/date-util";
import { Component, Vue } from "vue-property-decorator";
import { Action } from "vuex-class";
import { colorClassByStatus } from "@/utils/page-utils";

@Component({
  components: {},
  filters: {dateFilter},
  methods: {colorClassByStatus}
})
export default class CallDetailIncomingInfo extends Vue {

  @Action("getCallStatisticDetailIncomingInfo") actionGetItem: any;

  private messageInfo: any = {
    id: '',
    createDate: '',
    start_date: '',
    end_date: '',
    duration: '',
    module: '',
    originator: '',
    service_number: '',
    partner: '',
    status: '',
    content: '',
  };

  async created() {
    if (this.$route.params.id) {
      this.messageInfo = await this.actionGetItem(this.$route.params.id);
    }
  }

  back(): void {
    this.$router.push('/call/detail_incoming/');
  }
}
